// Desc: This page it will be displayed when the user tries to access a page that he doesn't have permission.
// update: 

// React
import React from 'react';

// Material UI Components
import Button from '@mui/material/Button';

// Render The Page
function AccessDenied() {
    return (
        <div style={{ display: 'flex', justifyContent: 'center', alignItems: 'center', height: '100vh' }}>
            <div style={{ border: '2px solid #fff', borderRadius: '50%', width: '500px', height: '500px', display: 'flex', justifyContent: 'center', alignItems: 'center', boxShadow: '0 0 10px 5px rgba(92, 94, 94, 0.2)' }}>
                <div style={{ display: 'flex', flexDirection: 'column', alignItems: 'center', justifyContent: 'center', height: '100%', gap: '1rem' }}>
                    <p style={{ fontWeight: 200, fontSize: '60px', textAlign: 'center', fontFamily: '"Open Sans", sans-serif', color: 'white', textShadow: '2px 2px 5px rgb(171, 160, 227)' }}>Acesso Restrito</p>
                    <p style={{ fontWeight: 200, fontSize: '16px', textAlign: 'center', fontFamily: '"Open Sans", sans-serif' }}>Parece que você tentou acessar uma área exclusiva. Se precisar de acesso, fale com a equipe responsável.</p>
                    <div style={{ marginTop: '20px' }}>
                        <Button href='/painel' variant="contained" sx={{ borderRadius: '20px', backgroundColor: 'rgb(171, 160, 227)' }}>
                            Voltar ao Painel
                        </Button>
                    </div>
                </div>
            </div>
        </div>
    );
}

export default AccessDenied;